/* eslint no-param-reassign: 0 */
import { BroadcastService } from '../services/broadcast.service';

const broadcastsState = {};

const mutations = {};

const getters = {};

const actions = {
  getBroadcasts: async (_, params = {}) => {
    let payload;

    if (!params.skipConf) {
      payload = {
        direction: 'asc',
        sort: 'scheduled_start_time',
        type: 'past',
        page: 1,
        per_page: 20,
        max_page: 1,
      };
    } else {
      payload = JSON.parse(JSON.stringify(params));
    }

    delete payload.skipConf;
    delete payload.max_page;
    delete payload.skipLoading;
    delete payload.skipState;

    try {
      const broadcasts = await BroadcastService.getBroadcasts(payload);
      return broadcasts;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  state: broadcastsState,
  mutations,
  getters,
  actions,
};
